export { default as NCard, cardProps } from './src/Card';
